export default __webpack_public_path__ + "static/media/pets.2082becc.jpg";